import { Avatar, Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";
import { Customer } from "../models";
import theme from "src/theme";
import RoleChip from "@arelia-components/ui-atoms/RoleChip";

type Props = {
  activeCustomer: Customer | null;
};

export default function QuickView({ activeCustomer }: Props) {
  return activeCustomer && <Box sx={styles.wrapperBox}>
    <Box sx={styles.userInfoBox}>
      <Avatar
        src={activeCustomer.avatarUrl}
        sx={styles.userInfoAvatar}
      />
      <Typography variant="h3" sx={styles.userInfoName}>{activeCustomer.band?.labelOrManager || activeCustomer.fullName}</Typography>
      <Typography sx={styles.userInfoStatus(activeCustomer.status === "Active")}>{activeCustomer.status}</Typography>
    </Box>
    <div style={styles.divider}></div>
    <Box sx={styles.userDetailsBox}>
      <Typography variant="h4">{activeCustomer.fullName}</Typography>
      <Typography>{activeCustomer.phone}</Typography>
      <Typography color="primary">{activeCustomer.email}</Typography>
      <RoleChip role={activeCustomer.role} sx={{ my: 2 }} />
    </Box>
    <Link to={"/hq/customers/" + activeCustomer.identityId}>
      <Button variant="contained" sx={styles.actionBbutton} size="large">View Full Profile</Button>
    </Link>
  </Box>;
}

const styles = {
  wrapperBox: {
    display: "flex",
    marginTop: "40px",
    flexDirection: "column"
  },
  userInfoBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },
  userInfoAvatar: {
    width: "148px",
    height: "148px",
  },
  userInfoName: {
    marginTop: "20px"
  },
  userInfoStatus: (active: boolean) => ({
    fontSize: "10px",
    fontWeight: 500,
    textTransform: "uppercase",
    color: active ? theme.palette.success.main : 'secondary'
  }),
  divider: {
    backgroundColor: "rgba(129, 140, 155, 0.2)",
    height: "1px",
    width: "100%",
    margin: "30px 0"
  },
  userDetailsBox: {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
    flexDirection: "column"
  },
  actionBbutton: {
    width: "100%"
  }
}